/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SafelinkDefs from './defs.defs.js'

const $nsid = 'tools.ozone.safelink.queryRules'

export { $nsid }

/** Query URL safety rules */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    urls: l.optional(l.array(l.string())),
    patternType: l.optional(l.string()),
    actions: l.optional(l.array(l.string())),
    reason: l.optional(l.string()),
    createdBy: l.optional(l.string({ format: 'did' })),
    sortDirection: l.optional(
      l.withDefault(l.string<{ knownValues: ['asc', 'desc'] }>(), 'desc'),
    ),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    rules: l.array(
      l.ref<SafelinkDefs.UrlRule>((() => SafelinkDefs.urlRule) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
